import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const FuncoesDefault = Default

export default FuncoesDefault;
export const FuncoesAdicionar = Adicionar;
export const FuncoesEditar = Editar;
